module.exports = __webpack_public_path__ + "static/media/light.c34cbf19.png";